interface CollectMetadataModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any;
}

export function CollectMetadataModal({ isOpen, onClose, data }: CollectMetadataModalProps) {
  if (!isOpen) return null;

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    } catch {}
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-navy-800 border border-navy-700 rounded-lg p-4 w-[560px] max-h-[70vh] overflow-auto">
        <div className="text-sm text-gray-100 mb-3">Metadados coletados</div>
        <pre className="text-[11px] leading-tight text-gray-300 bg-navy-900 border border-navy-700 rounded p-2 overflow-auto">
          {JSON.stringify(data, null, 2)}
        </pre>
        <div className="flex justify-end gap-2 mt-3">
          <button
            onClick={handleCopyToClipboard}
            className="px-3 py-1.5 text-xs rounded border border-navy-600 text-gray-300 hover:bg-navy-700"
          >Copiar JSON</button>
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-xs rounded bg-blue-600 hover:bg-blue-500 text-white"
          >Fechar</button>
        </div>
      </div>
    </div>
  );
}
